// TaskSlide.tsx
import React from "react";

export default function TaskSlide({
  slide,
  onCorrect,
  onIncorrect,
  message,
  setMessage
}) {

  // this checks code by calling a global validator that reads code from your editor.
  // We'll provide example `validateCurrentEditor` below in integration section.
  async function check() {
    // validateCurrentEditor is a function you implement in LMSPlayground that reads current editor content
    // and runs validation described in slide.task.validator
    const { valid, reason } = await (window).validateCurrentEditor?.(slide.task);
    if (valid) {
      setMessage("✅ Correct");
      onCorrect();
    } else {
      setMessage("❌ " + (reason || "Not correct yet"));
      onIncorrect();
    }
  }

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: slide.html }} />
      <div className="mt-3 flex gap-2">
        <button className="px-3 py-1 bg-blue-600 text-white rounded" onClick={check}>Check Solution</button>
        <div className="text-sm text-gray-600">{message}</div>
      </div>
    </div>
  );
}
